import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth.service';
import '../styles/SignInPage.css';

type Etat = 'verification' | 'ok' | 'echec';

/**
 * Cible du lien reçu par email. Route PUBLIQUE : le destinataire ouvre son
 * courrier dans le navigateur qu'il veut, souvent sans session ouverte.
 */
const VerifyEmailPage: React.FC = () => {
  const [params] = useSearchParams();
  const [etat, setEtat] = useState<Etat>('verification');
  // React 18 monte deux fois en développement : sans ce garde, l'appel part
  // en double et le second brouille l'affichage.
  const lance = useRef(false);

  useEffect(() => {
    if (lance.current) return;
    lance.current = true;

    const token = params.get('token');
    if (!token) {
      setEtat('echec');
      return;
    }
    authService
      .verifyEmail(token)
      .then(() => {
        authService.markEmailVerifiedLocally();
        setEtat('ok');
      })
      .catch(() => setEtat('echec'));
  }, [params]);

  return (
    <div className="signin-container">
      <div className="signin-card">
        <h1 className="signin-title">Coloc App</h1>

        {etat === 'verification' && (
          <>
            <h2 className="signin-subtitle">Vérification en cours…</h2>
          </>
        )}

        {etat === 'ok' && (
          <>
            <h2 className="signin-subtitle">Adresse confirmée</h2>
            <p>
              Merci — votre adresse est vérifiée. Vous pouvez maintenant mettre
              le site de votre colocation en ligne.
            </p>
            <div className="signin-links">
              <Link to="/dashboard" className="forgot-password-link">
                Aller au tableau de bord
              </Link>
            </div>
          </>
        )}

        {etat === 'echec' && (
          <>
            <h2 className="signin-subtitle">Lien invalide ou expiré</h2>
            <p>
              Ce lien n&apos;est plus valable. Connectez-vous et demandez un
              nouvel envoi depuis « Mon compte ».
            </p>
            <div className="signin-links">
              <Link to="/signin" className="forgot-password-link">
                Se connecter
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
